var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row footer-position-bottom-stikcy mt-3",staticStyle:{"background":"white","border-radius":"4px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }